(function (app) {
    app.provider("loginIframeService", ["figAuthSettings", function (figAuthSettings) {
        this.$get = [function () {
            var iframe = null;
            var src = figAuthSettings.baseUrl + "/Login";

            return {
                registerIframe: function(elem) {
                    iframe = elem;
                    iframe.src = src;

                    function receiveMessage(event) {
                        console.log(event);
                    }

                    iframe.addEventListener("message", receiveMessage, false);
                    
                },
                sendToIframe: function (message) {
                    console.log(message + " -> " + src);
                    return iframe.contentWindow.postMessage(message, src);
                }
            };
        }];
    }]);
})(window.app);